import React, { Children } from 'react';
import { Star, ShieldCheck, Clock, Award, UserPlus } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section id="testimonials" className="py-10 bg-gray-50" data-id="element-454">
      <div className="container mx-auto px-4" data-id="element-455">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-456">
          <h2 className="text-3xl font-bold mb-8 text-gray-800" data-id="element-457">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <motion.div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16" variants={container} initial="hidden" animate="show" data-id="element-458">
            <motion.div className="bg-white p-6 rounded-xl shadow-sm" variants={item} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} data-id="element-459">
              <div className="flex items-center mb-4" data-id="element-460">
                <ShieldCheck size={24} className="text-blue-600 mr-3 flex-shrink-0" data-id="element-461" />
                <h3 className="text-xl font-bold text-blue-600" data-id="element-462">
                  ¿Y si no me sirve?
                </h3>
              </div>
              <p data-id="element-463">
                Tiene garantía total. Si no te ayuda, te devolvemos tu dinero.
              </p>
              <motion.div className="mt-4 bg-blue-50 p-2 rounded-lg text-sm" animate={{
              scale: [1, 1.03, 1]
            }} transition={{
              repeat: Infinity,
              duration: 3
            }} data-id="element-464">
                <p className="font-medium text-blue-700" data-id="element-465">
                  100% GARANTIZADO o te devolvemos tu dinero
                </p>
              </motion.div>
            </motion.div>
            <motion.div className="bg-white p-6 rounded-xl shadow-sm" variants={item} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} data-id="element-466">
              <div className="flex items-center mb-4" data-id="element-467">
                <Award size={24} className="text-blue-600 mr-3 flex-shrink-0" data-id="element-468" />
                <h3 className="text-xl font-bold text-blue-600" data-id="element-469">
                  ¿Es confiable?
                </h3>
              </div>
              <p data-id="element-470">
                Médicos, fisioterapeutas y expertos en neurología lo
                recomiendan.
              </p>
              <motion.div className="mt-4 bg-blue-50 p-2 rounded-lg text-sm" animate={{
              scale: [1, 1.03, 1]
            }} transition={{
              repeat: Infinity,
              duration: 3,
              delay: 0.5
            }} data-id="element-471">
                <p className="font-medium text-blue-700" data-id="element-472">
                  AVALADO por especialistas en salud
                </p>
              </motion.div>
            </motion.div>
            <motion.div className="bg-white p-6 rounded-xl shadow-sm" variants={item} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} data-id="element-473">
              <div className="flex items-center mb-4" data-id="element-474">
                <Clock size={24} className="text-blue-600 mr-3 flex-shrink-0" data-id="element-475" />
                <h3 className="text-xl font-bold text-blue-600" data-id="element-476">¿Es fácil?</h3>
              </div>
              <p data-id="element-477">Colócalo. Respira. 15 minutos. Natural. Simple. Real.</p>
              <motion.div className="mt-4 bg-blue-50 p-2 rounded-lg text-sm" animate={{
              scale: [1, 1.03, 1]
            }} transition={{
              repeat: Infinity,
              duration: 3,
              delay: 1
            }} data-id="element-478">
                <p className="font-medium text-blue-700" data-id="element-479">
                  RESULTADOS en minutos, no días
                </p>
              </motion.div>
            </motion.div>
          </motion.div>
          <motion.div className="flex items-center justify-center space-x-2 mb-12" animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} data-id="element-480">
            <Star fill="currentColor" size={20} className="text-yellow-400" data-id="element-481" />
            <p className="text-xl" data-id="element-482">
              Más de{' '}
              <span className="font-bold underline" data-id="element-483">12,000 personas</span> ya lo
              usan y recomiendan:
            </p>
          </motion.div>
        </motion.div>
        <motion.div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" variants={container} initial="hidden" animate="show" data-id="element-484">
          <motion.div className="bg-white p-6 rounded-xl shadow-md" variants={item} whileHover={{
          scale: 1.03
        }} data-id="element-485">
            <div className="flex text-yellow-400 mb-4" data-id="element-486">
              <Star fill="currentColor" size={20} data-id="element-487" />
              <Star fill="currentColor" size={20} data-id="element-488" />
              <Star fill="currentColor" size={20} data-id="element-489" />
              <Star fill="currentColor" size={20} data-id="element-490" />
              <Star fill="currentColor" size={20} data-id="element-491" />
            </div>
            <p className="mb-4 italic" data-id="element-492">"No más analgésicos. ¡Es otra vida!"</p>
            <div className="flex items-center" data-id="element-493">
              <motion.img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Foto de perfil de María T." className="w-10 h-10 rounded-full object-cover mr-3" whileHover={{
              scale: 1.1
            }} data-id="element-494" />
              <div data-id="element-495">
                <span className="font-semibold block" data-id="element-496">María T.</span>
                <span className="text-xs text-gray-500" data-id="element-497">Hace 2 semanas</span>
              </div>
            </div>
            <motion.div className="mt-4 bg-green-50 p-2 rounded-lg text-sm" animate={{
            opacity: [0.8, 1, 0.8]
          }} transition={{
            repeat: Infinity,
            duration: 2
          }} data-id="element-498">
              <p className="text-green-700 font-medium" data-id="element-499">Compra verificada ✓</p>
            </motion.div>
          </motion.div>
          <motion.div className="bg-white p-6 rounded-xl shadow-md" variants={item} whileHover={{
          scale: 1.03
        }} data-id="element-500">
            <div className="flex text-yellow-400 mb-4" data-id="element-501">
              <Star fill="currentColor" size={20} data-id="element-502" />
              <Star fill="currentColor" size={20} data-id="element-503" />
              <Star fill="currentColor" size={20} data-id="element-504" />
              <Star fill="currentColor" size={20} data-id="element-505" />
              <Star fill="currentColor" size={20} data-id="element-506" />
            </div>
            <p className="mb-4 italic" data-id="element-507">
              "Me sentí mejor sin meterle nada raro al cuerpo."
            </p>
            <div className="flex items-center" data-id="element-508">
              <motion.img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Foto de perfil de Juan R." className="w-10 h-10 rounded-full object-cover mr-3" whileHover={{
              scale: 1.1
            }} data-id="element-509" />
              <div data-id="element-510">
                <span className="font-semibold block" data-id="element-511">Juan R.</span>
                <span className="text-xs text-gray-500" data-id="element-512">Hace 5 días</span>
              </div>
            </div>
            <motion.div className="mt-4 bg-green-50 p-2 rounded-lg text-sm" animate={{
            opacity: [0.8, 1, 0.8]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            delay: 0.3
          }} data-id="element-513">
              <p className="text-green-700 font-medium" data-id="element-514">Compra verificada ✓</p>
            </motion.div>
          </motion.div>
          <motion.div className="bg-white p-6 rounded-xl shadow-md" variants={item} whileHover={{
          scale: 1.03
        }} data-id="element-515">
            <div className="flex text-yellow-400 mb-4" data-id="element-516">
              <Star fill="currentColor" size={20} data-id="element-517" />
              <Star fill="currentColor" size={20} data-id="element-518" />
              <Star fill="currentColor" size={20} data-id="element-519" />
              <Star fill="currentColor" size={20} data-id="element-520" />
              <Star fill="currentColor" size={20} data-id="element-521" />
            </div>
            <p className="mb-4 italic" data-id="element-522">"Es mi nueva rutina de autocuidado."</p>
            <div className="flex items-center" data-id="element-523">
              <motion.img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80" alt="Foto de perfil de Laura P." className="w-10 h-10 rounded-full object-cover mr-3" whileHover={{
              scale: 1.1
            }} data-id="element-524" />
              <div data-id="element-525">
                <span className="font-semibold block" data-id="element-526">Laura P.</span>
                <span className="text-xs text-gray-500" data-id="element-527">Hace 1 semana</span>
              </div>
            </div>
            <motion.div className="mt-4 bg-green-50 p-2 rounded-lg text-sm" animate={{
            opacity: [0.8, 1, 0.8]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            delay: 0.6
          }} data-id="element-528">
              <p className="text-green-700 font-medium" data-id="element-529">Compra verificada ✓</p>
            </motion.div>
          </motion.div>
        </motion.div>
        <motion.div className="text-center mt-12" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-530">
          <motion.p className="text-xl font-semibold text-blue-600" animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} data-id="element-531">
            💬 Miles ya rompieron la cadena.{' '}
            <span className="underline" data-id="element-532">Ahora te toca a ti.</span>
          </motion.p>
          <motion.a href="https://shopysv.com/products/pide-tu-gorro-anti-migrana" className="mt-6 inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-533">
            <span data-id="element-534">Unirme a ellos ahora</span>
            <motion.div animate={{
            x: [0, 5, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.5
          }} className="ml-2" data-id="element-535">
              <UserPlus size={18} data-id="element-536" />
            </motion.div>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}